import { Main } from 'element-ui'
import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '@/views/index.vue'
import RouteReplaceSelf from "@/utils/routeReplaceSelf";

Vue.use(VueRouter)
// 获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
// 修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
// const origina = Router.prototype.push
// Router.prototype.push=function push (location) {
//     return origina.call(this,location).catch(err => err)
// }
const routes = [

    {
        path: '/',
        name: 'index',
        component: Index,
        redirect: (to) => {
            let user_type = localStorage.getItem('user_type');
            if (user_type == null || user_type == 1) {
                return "/personal"
            } else {
                return "/director"
            }
        },
        children: [

            {
                path: '/company-index',
                name: 'company-index',
                component: () =>
                    import('@/views/company/company-index.vue')
            },


            {
                path: '/job-detail',
                name: 'job-detail',
                component: () =>
                    import('@/views/personal/job/job-detail.vue'),

            },

            {
                path: '/position-detail',
                name: 'position-detail',
                component: () =>
                    import('@/views/personal/job/position-detail.vue'),
            },


            {
                path: '/member-index',
                name: 'member-index',
                component: () =>
                    import('@/views/member/member-index.vue')
            },


            // 主管主页
            {
                path: '/manager-index',
                name: 'manager-index',
                component: () =>
                    import('@/views/member/manager-index.vue')
            },

                 //聊呗 （公共的）
            {
                path: '/chat',
                name: 'chat',
                redirect: '/chat-info',
            // component: Index,
                component: () =>import('@/views/chat/chat-index.vue'),
                children: [
                    // 聊天信息
                    {
                        path: '/chat-info',
                        name: 'chat-info',
                        component: () =>
                            import('@/views/chat/chat-info.vue'),
                    },
                    // 通讯录
                    {
                        path: '/chat-addbook',
                        name: 'chat-addbook',
                        component: () =>
                            import('@/views/chat/chat-addbook.vue'),
                    },
                    // 平台信息
                    {
                        path: '/chat-pla',
                        name: 'chat-pla',
                        component: () =>
                            import('@/views/chat/chat-pla.vue'),
                    },
                    // 客服
                    {
                        path: '/chat-service',
                        name: 'chat-service',
                        component: () =>
                            import('@/views/chat/chat-service.vue'),
                    },

                    // 客服
                    {
                        path: '/chat-setting',
                        name: 'chat-setting',
                        component: () =>
                            import('@/views/chat/chat-setting.vue'),
                    },

                ]
            },

            //人脉圈
             {
                path: '/relation',
                name: 'relation',
                redirect: '/relation-friend',
                component: () =>import('@/views/relation/relation-index.vue'),
                children: [
                      // 好友
                      {
                        path: '/relation-friend',
                        name: 'relation-friend',
                        redirect: '/relation-friend-index',
                        component: () => import('@/views/relation/friend/friend-index.vue'),
                    },

                    // 好友
                    {
                        path: '/relation-friend-index',
                        name: 'relation-friend-index',
                        component: () => import('@/views/relation/friend/friend-index.vue'),
                    },

                     // 粉丝
                     {
                        path: '/relation-friend-fans',
                        name: 'relation-friend-fans',
                        component: () => import('@/views/relation/friend/friend-fans.vue'),
                    },

                     // 关注的
                     {
                        path: '/relation-friend-follow',
                        name: 'relation-friend-follow',
                        component: () => import('@/views/relation/friend/friend-follow.vue'),
                    },


                    //推广人才
                    {
                        path: '/relation-promotion',
                        name: 'relation-promotion',
                        component: () => import('@/views/relation/promotion/promotion-user.vue'),
                    },

                    //推广企业
                    {
                        path: '/relation-promotion-company',
                        name: 'relation-promotion-company',
                        component: () => import('@/views/relation/promotion/promotion-company.vue'),
                    },


                     //委托推广
                     {
                        path: '/relation-promotion-user-two',
                        name: 'relation-promotion-user-two',
                        component: () => import('@/views/relation/promotion/promotion-user-two.vue'),
                    },





                    {
                        path: '/relation-team',
                        name: 'relation-team',
                        component: () => import('@/views/relation/team/team-index.vue'),
                    },

                    {
                        path: '/relation-team-join',
                        name: 'relation-team-join',
                        component: () => import('@/views/relation/team/team-join.vue'),
                    },

                    {
                        path: '/relation-team-follow',
                        name: 'relation-team-follow',
                        component: () => import('@/views/relation/team/team-follow.vue'),
                    },


                  

                    //我加入的
                    {
                        path: '/relation-company-join',
                        name: 'relation-company-join',
                        component: () => import('@/views/relation/company/company-join.vue'),
                    },


                    //我工作的
                    {
                        path: '/relation-company-work',
                        name: 'relation-company-work',
                        component: () => import('@/views/relation/company/company-work.vue'),
                    },

                      //我关注的
                      {
                        path: '/relation-company-follow',
                        name: 'relation-company-follow',
                        component: () => import('@/views/relation/company/company-follow.vue'),
                    },





                    {
                        path: '/relation-community',
                        name: 'relation-community',
                        component: () => import('@/views/relation/community/community-index.vue'),
                    },


                ]


             },
    


        ]
    },





    //主管
    {
        path: '/director',
        name: 'director',
        redirect: '/director-talent', //默认到找人才
        component: Index,
        children: [
            // 工作台
            {
                path: '/director-work',
                name: 'director-work',
               // redirect: '/director-work-project',
                component: () => import('@/views/director/work/work-index.vue'),
               
            },

            // 发布项目
            {
                path: '/director-work-project',
                name: 'director-work-project',
                component: () =>
                    import('@/views/director/work/project/project-list.vue'),
            },

             // 项目设置
             {
                path: '/director-work-project-setting',
                name: 'director-work-project-setting',
                component: () =>
                    import('@/views/director/work/project/setting/index.vue'),
            },


            // 发布需求
            {
                path: '/director-work-demand',
                name: 'director-work-demand',
                component: () =>
                    import('@/views/director/work/demand/demand-list.vue'),
            },

            //发布招聘需求
            {
                path: '/director-demand-publish',
                name: 'director-demand-publish',
                component: () =>
                    import('@/views/director/work/demand/demand-publish.vue'),
            },



            // 众包管理--暂时用不到
            {
                path: '/director-work-package',
                name: 'director-work-package',
                component: () =>
                    import('@/views/director/work/package/package-list.vue'),
            },
            // 招聘
            {
                path: '/director-work-recruit',
                name: 'director-work-recruit',
                component: () => import('@/views/director/work/recruit/recruit-index.vue'),
                redirect: '/director-work-recruit-apply',
                children: [
                    {
                        path: '/director-work-recruit-apply',
                        name: 'director-work-recruit-apply',
                        component: () =>
                            import('@/views/director/work/recruit/recruit-apply.vue'),
                    },

                    {
                        path: '/director-work-recruit-address',
                        name: 'director-work-recruit-address',
                        component: () =>
                            import('@/views/director/work/recruit/recruit-address.vue'),
                    },

                    {
                        path: '/director-work-recruit-contract',
                        name: 'director-work-recruit-contract',
                        component: () =>
                            import('@/views/director/work/recruit/recruit-contract.vue'),
                    },


                    {
                        path: '/director-work-recruit-evaluate',
                        name: 'director-work-recruit-evaluate',
                        component: () =>
                            import('@/views/director/work/recruit/recruit-evaluate.vue'),
                    },


                ]
            },
            // 招标
            {
                path: '/director-work-bidding',
                name: 'director-work-bidding',
                component: () =>
                    import('@/views/director/work/bidding/bidding-list.vue'),
            },
            // 地址管理
            {
                path: '/director-work-address',
                name: 'director-work-address',
                component: () =>
                    import('@/views/director/work/address/address-list.vue'),
            },

            // 工作通
            {
                path: '/director-workmaster',
                name: 'director-workmaster',
                component: RouteReplaceSelf(() => import("@/views/director/workmaster/workmaster-index.vue")),
                children: [
                    {
                        path: '/director-workmaster-contacts',
                        name: 'director-workmaster-contacts',
                        component: () =>
                            import('@/views/director/workmaster/contacts/contacts-index.vue'),
                    },



                    {
                        path: '/director-workmaster-report',
                        name: 'director-workmaster-report',
                        component: () =>
                            import('@/views/director/workmaster/application/report/index.vue'),
                    },


                    {
                        path: '/director-workmaster-report-set',
                        name: 'director-workmaster-report-set',
                        component: () =>
                            import('@/views/director/workmaster/application/report/set.vue'),
                    },


                    {
                        path: '/director-workmaster-report-list',
                        name: 'director-workmaster-report-list',
                        component: () =>
                            import('@/views/director/workmaster/application/report/list.vue'),
                    },



                    {
                        path: '/director-workmaster-clock',
                        name: 'director-workmaster-clock',
                        component: () =>
                            import('@/views/director/workmaster/application/clock/index.vue'),
                    },



                    {
                        path: '/director-workmaster-clock-edit-in',
                        name: 'director-workmaster-clock-edit-in',
                        component: () =>
                            import('@/views/director/workmaster/application/clock/edit_in.vue'),
                    },


                    {
                        path: '/director-workmaster-clock-edit-out',
                        name: 'director-workmaster-clock-edit-out',
                        component: () =>
                            import('@/views/director/workmaster/application/clock/edit_out.vue'),
                    },


                    {
                        path: '/director-workmaster-clock-day',
                        name: 'director-workmaster-clock-day',
                        component: () =>
                            import('@/views/director/workmaster/application/clock/report_day.vue'),
                    },


                    {
                        path: '/director-workmaster-clock-month',
                        name: 'director-workmaster-clock-month',
                        component: () =>
                            import('@/views/director/workmaster/application/clock/report_month.vue'),
                    },

                    {
                        path: '/director-workmaster-approval',
                        name: 'director-workmaster-approval',
                        component: () =>
                            import('@/views/director/workmaster/application/approval/index.vue'),
                    },

                    {
                        path: '/director-workmaster-approval-list',
                        name: 'director-workmaster-approval-list',
                        component: () =>
                            import('@/views/director/workmaster/application/approval/list.vue'),
                    },


                    {
                        path: '/director-workmaster-approval-set',
                        name: 'director-workmaster-approval-set',
                        component: () =>
                            import('@/views/director/workmaster/application/approval/set.vue'),
                    },


                ]
            },

            //招标
            {
                path: '/bidding',
                name: 'bidding',
                redirect: '/bidding-list', //
                component: () =>
                    import('@/views/director/work/package/bidding/mine/index.vue'),
                children: [
                    {
                        path: '/bidding-list',
                        name: 'bidding-list',
                        component: () =>
                            import('@/views/director/work/package/bidding/mine/bidding-list.vue')
                    },

                    {
                        path: '/bidding-detail',
                        name: 'bidding-detail',
                        component: () =>
                            import('@/views/director/work/package/bidding/mine/bidding-detail.vue')
                    },


                    {
                        path: '/bidding-records',
                        name: 'bidding-records',
                        component: () =>
                            import('@/views/director/work/package/bidding/mine/bidding-records.vue')
                    },


                    {
                        path: '/bidding-release',
                        name: 'bidding-release',
                        component: () =>
                            import('@/views/director/work/package/bidding/mine/bidding-release.vue')
                    },


                    {
                        path: '/bidding-records-detail',
                        name: 'bidding-records-detail',
                        component: () =>
                            import('@/views/director/work/package/bidding/mine/records-detail.vue')
                    },

                ]

            },

            //src/views/director/work/package/bidding/join
            //招投标
            {
                path: '/tender',
                name: 'tender',
                redirect: '/tender-list', //
                component: () =>
                    import('@/views/director/work/package/bidding/join/index.vue'),
                children: [

                    {
                        path: '/tender-all',
                        name: 'tender-all',
                        component: () =>
                            import('@/views/director/work/package/bidding/join/tender-all.vue')
                    },

                    {
                        path: '/tender-all-detail',
                        name: 'tender-all-detail',
                        component: () =>
                            import('@/views/director/work/package/bidding/join/tender-all-detail.vue')
                    },

                    {
                        path: '/tender-list',
                        name: 'tender-list',
                        component: () =>
                            import('@/views/director/work/package/bidding/join/tender-list.vue')
                    },



                    {
                        path: '/tender-records',
                        name: 'tender-records',
                        component: () =>
                            import('@/views/director/work/package/bidding/join/tender-records.vue')
                    },
                    {
                        path: '/tender-detail',
                        name: 'tender-detail',
                        component: () =>
                            import('@/views/director/work/package/bidding/join/tender-detail.vue')
                    },



                ]

            },


            //帮忙
            {
                path: '/help-mine',
                name: 'help-mine',
                redirect: '/help-mine-list', //
                component: () =>
                    import('@/views/director/work/package/help/mine/index.vue'),
                children: [
                    {
                        path: '/help-mine-list',
                        name: 'help-mine-list',
                        component: () =>
                            import('@/views/director/work/package/help/mine/help-list.vue'),
                    },
                    {
                        path: '/help-mine-records',
                        name: 'help-mine-records',
                        component: () =>
                            import('@/views/director/work/package/help/mine/help-records.vue'),
                    },
                    {
                        path: '/help-mine-records-detail',
                        name: 'help-mine-records-detail',
                        component: () =>
                            import('@/views/director/work/package/help/mine/records-detail.vue'),
                    },


                    {
                        path: '/help-mine-release',
                        name: 'help-mine-release',
                        component: () =>
                            import('@/views/director/work/package/help/mine/help-release.vue'),
                    },


                    {
                        path: '/help-mine-detail',
                        name: 'help-mine-detail',
                        component: () =>
                            import('@/views/director/work/package/help/mine/help-detail.vue'),
                    },




                ]

            },

            //我加入的帮忙  
            {
                path: '/help-join',
                name: 'help-join',
                redirect: '/help-join-list', //
                component: () =>
                    import('@/views/director/work/package/help/join/index.vue'),
                children: [
                    {
                        path: '/help-join-list',
                        name: 'help-join-list',
                        component: () =>
                            import('@/views/director/work/package/help/join/join-list.vue'),
                    },

                    {
                        path: '/help-join-detail',
                        name: 'help-join-detail',
                        component: () =>
                            import('@/views/director/work/package/help/join/join-detail.vue'),
                    },

                    {
                        path: '/help-join-all',
                        name: 'help-join-all',
                        component: () =>
                            import('@/views/director/work/package/help/join/all.vue'),
                    },

                    {
                        path: '/help-join-all-detail',
                        name: 'help-join-all-detail',
                        component: () =>
                            import('@/views/director/work/package/help/join/all-detail.vue'),
                    },



                ]

            },


            //找人才
            {
                path: '/director-talent',
                name: 'director-talent',
                component: () =>
                    import('@/views/director/talent/talent-index.vue'),
            },

            // 搜索
            {
                path: '/search',
                name: 'search',
                component: () =>
                    import('@/views/director/talent/search-index.vue')
            },



       


            //面试宝
            {
                path: '/director-audition',
                name: 'director-audition',
                redirect: '/director-audition-list',
                component: () =>
                    import('@/views/director/audition/audition-index.vue'),

                children: [{
                    path: '/director-audition-list',
                    name: 'director-audition-list',
                    component: () =>
                        import('@/views/director/audition/audition-list.vue'),
                },
                {
                    path: '/director-audition-result',
                    name: 'director-audition-result',
                    component: () =>
                        import('@/views/director/audition/audition-result.vue'),
                },
                ]
            },

            //面试宝设置    
            {
                path: '/director-audition-setting',
                name: 'director-audition-setting',
                component: () =>
                    import('@/views/director/audition/setting/index.vue'),
            },


            //企业端主管支付
            {
                path: '/director-pay',
                name: 'director-pay',
                component: () =>
                    import('@/views/director/pay/index.vue'),


            },

            {
                path: '/director-pay-pwd',
                name: 'director-pay-pwd',
                component: () =>
                    import('@/views/director/pay/pwd.vue'),


            },


     


            //企业入口
            {
                path: '/director-company',
                name: 'director-company',
                component: () =>
                    import('@/views/director/company/company-index.vue'),
            },


            //团队登录
            {
                path: '/director-team',
                name: 'director-team',
                component: () =>
                    import('@/views/director/team/team-index.vue'),
            },


        ]
    },


    //求职端
    {
        path: '/personal',
        name: 'personal',
        redirect: '/personal-job', //找工作默认
        component: Index,
        children: [

            // 工作台
            {
                path: '/personal-work',
                name: 'personal-work',
                component: RouteReplaceSelf(() => import("@/views/personal/work/work-index.vue")),
                children: [
                    {
                        path: '/personal-work-index',
                        name: 'personal-work-index',
                        component: () =>
                            import('@/views/personal/work/work-index.vue'),
                    },

                   


                    //请假
                    {
                        path: '/personal-work-approval-leave',
                        name: 'personal-work-approval-leave',
                        redirect: '/personal-work-approval-leave-index', //
                        component: () =>
                            import('@/views/personal/work/approval/leave/approval-leave.vue'),
                        children: [
                            {
                                path: '/personal-work-approval-leave-index',
                                name: 'personal-work-approval-leave-index',
                                component: () =>
                                    import('@/views/personal/work/approval/leave/approval-leave-index.vue')
                            },

                            {
                                path: '/personal-work-approval-leave-info',
                                name: 'personal-work-approval-leave-info',
                                component: () =>
                                    import('@/views/personal/work/approval/leave/approval-leave-info.vue')
                            },
                        ]
                    },



                    //收款
                    {
                        path: '/personal-work-approval-collection',
                        name: 'personal-work-approval-collection',
                        redirect: '/personal-work-approval-collection-index', //
                        component: () =>
                            import('@/views/personal/work/approval/collection/approval-collection.vue'),
                        children: [
                            {
                                path: '/personal-work-approval-collection-index',
                                name: 'personal-work-approval-collection-index',
                                component: () =>
                                    import('@/views/personal/work/approval/collection/approval-collection-index.vue')
                            },


                        ]


                    },


                    //出差
                    {
                        path: '/personal-work-approval-travel',
                        name: '/personal-work-approval-travel',
                        redirect: '/personal-work-approval-travel-index', //
                        component: () =>
                            import('@/views/personal/work/approval/travel/approval-travel.vue'),
                        children: [
                            {
                                path: '/personal-work-approval-travel-index',
                                name: 'personal-work-approval-travel-index',
                                component: () =>
                                    import('@/views/personal/work/approval/travel/approval-travel-index.vue')
                            },

                            {
                                path: '/personal-work-approval-travel-info',
                                name: 'personal-work-approval-travel-info',
                                component: () =>
                                    import('@/views/personal/work/approval/travel/approval-travel-info.vue')
                            },
                        ]
                    },
                    //报销
                    {
                        path: '/personal-work-approval-reimbursement',
                        name: 'personal-work-approval-reimbursement',
                        redirect: '/personal-work-approval-reimbursement-index', //
                        component: () =>
                            import('@/views/personal/work/approval/reimbursement/approval-reimbursement.vue'),
                        children: [
                            {
                                path: '/personal-work-approval-reimbursement-index',
                                name: 'personal-work-approval-reimbursement-index',
                                component: () =>
                                    import('@/views/personal/work/approval/reimbursement/approval-reimbursement-index.vue')
                            },
                            {
                                path: '/personal-work-approval-reimbursement-info',
                                name: 'personal-work-approval-reimbursement-info',
                                component: () =>
                                    import('@/views/personal/work/approval/reimbursement/approval-reimbursement-info.vue')
                            }
                        ]


                    },






                    //战报日报提交
                    {
                        path: '/personal-work-report-day',
                        name: 'personal-work-report-day',
                        redirect: '/personal-work-report-day-index', //
                        component: () =>
                            import('@/views/personal/work/report/day/report-day.vue'),
                        children: [
                            {
                                path: '/personal-work-report-day-index',
                                name: 'personal-work-report-day-index',
                                component: () =>
                                    import('@/views/personal/work/report/day/report-day-index.vue'),
                            }
                        ]
                    },

                    {
                        path: '/personal-work-report-week',
                        name: 'personal-work-report-week',
                        redirect: '/personal-work-report-week-index', //
                        component: () =>
                            import('@/views/personal/work/report/week/report-week.vue'),
                        children: [
                            {
                                path: '/personal-work-report-week-index',
                                name: 'personal-work-report-week-index',
                                component: () =>
                                    import('@/views/personal/work/report/week/report-week-index.vue'),
                            }
                        ]
                    },

                    //战报月报
                    {
                        path: '/personal-work-report-month',
                        name: 'personal-work-report-month',
                        redirect: '/personal-work-report-month-index', //
                        component: () =>
                            import('@/views/personal/work/report/month/report-month.vue'),
                        children: [
                            {
                                path: '/personal-work-report-month-index',
                                name: 'personal-work-report-month-index',
                                component: () =>
                                    import('@/views/personal/work/report/month/report-month-index.vue'),
                            }
                        ]
                    },

                    //战报记录
                    {
                        path: '/personal-work-report-record',
                        name: 'personal-work-report-record',
                        redirect: '/personal-work-report-record-index', //
                        component: () =>
                            import('@/views/personal/work/report/record/report-record.vue'),
                        children: [
                            {
                                path: '/personal-work-report-record-index',
                                name: 'personal-work-report-record-index',
                                component: () =>
                                    import('@/views/personal/work/report/record/report-record-index.vue'),
                            }
                        ]
                    },

                    //职位列表

                    {
                        path: '/personal-enroll-job',
                        name: 'personal-enroll-job',
                        redirect: '/personal-enroll-job-ing', //
                        component: () =>
                            import('@/views/personal/enroll/job/job-index.vue'),
                        children: [

                            {
                                path: '/personal-enroll-job-ing',
                                name: 'personal-enroll-job-ing',
                                component: () =>
                                    import('@/views/personal/enroll/job/job-ing.vue'),
                            },
                            {
                                path: '/personal-enroll-job-enroll',
                                name: 'personal-enroll-job-enroll',
                                component: () =>
                                    import('@/views/personal/enroll/job/job-enroll.vue'),
                            },


                            {
                                path: '/personal-enroll-job-list',
                                name: 'personal-enroll-job-list',
                                component: () =>
                                    import('@/views/personal/enroll/job/job-list.vue'),
                            },
                            {
                                path: "/personal-enroll-job-detail",
                                name: "personal-enroll-job-detail",
                                component: () =>
                                    import('@/views/personal/enroll/job/detail.vue'),
                            }


                        ]
                    },
                   
                ]

            },

            //找职位
            {
                path: '/personal-job',
                name: 'personal-job',
                component: () =>
                    import('@/views/personal/job/job-index.vue'),
            },

            // 搜索
            {
                path: '/job-search',
                name: 'job-search',
                component: () =>
                    import('@/views/personal/job/job-search.vue')
            },

            // 更多
            {
                path: '/job-more',
                name: 'job-more',
                component: () =>
                    import('@/views/personal/job/job-more.vue')
            },

           


            //团队登录
            {
                path: '/personal-team',
                name: 'personal-team',
                component: () =>
                    import('@/views/personal/team/team-index.vue'),
            },

        ]
    },


    //用户中心
    {
        path: '/member',
        name: 'member',
        component: Index,
        children: [
            // member
            // 切换身份
            {
                path: '/member-status',
                name: 'member-status',
                component: () =>
                    import('@/views/member/change-status.vue'),
            },
            // 个人中心
            {
                path: '/member-center',
                name: 'member-center',
                component: () =>
                    import('@/views/member/member-center.vue')
            },
            // 个人信息
            {
                path: '/member-detail',
                name: 'member-detail',
                component: () =>
                    import('@/views/member/member-detail.vue')
            },
            // 我的红包
            {
                path: '/member-redbag',
                name: 'member-redbag',
                component: () =>
                    import('@/views/member/red-bag.vue')
            },


            //切换身份
            {
                path: '/change-status',
                name: 'change-status',
                component: () =>
                    import('@/views/member/change-status.vue'),
            },


            // 我的简历
            {
                path: '/member-resume',
                name: 'member-resume',
                component: () =>
                    import('@/views/user/resume/list.vue')
            },

              // 简历主页
              {
                path: '/resume-detail',
                name: 'resume-detail',
                component: () =>
                    import('@/views/user/resume/show.vue')
            },



            // 发布简历
            {
                path: '/publish-resume',
                name: 'publish-resume',
                component: () =>
                    import('@/views/user/resume/publish.vue')
            },

              // 收藏
              {
                path: '/member-collect',
                name: 'member-collect',
                component: () => import('@/views/member/collect/collect-index.vue'),
                redirect: '/collect-job',
                children: [
                    {
                        path: '/collect-job',
                        name: 'collect-job',
                        component: () =>
                            import('@/views/member/collect/collect-job.vue'),
                    },

                    {
                        path: '/collect-crowd',
                        name: 'collect-crowd',
                        component: () =>
                            import('@/views/member/collect/collect-crowd.vue'),
                    },

                   


                ]
            },

              // 投诉列表
              {
                path: '/member-complaint',
                name: 'member-complaint',
                component: () =>
                    import('@/views/member/complaint/list.vue')
            },










        ]
    },

    // 登录
    {
        path: '/login',
        name: 'login',
        component: () =>
            import('@/views/user/login.vue')
    },
    // 找回密码
    {
        path: '/getpwd',
        name: 'getpwd',
        component: () =>
            import('@/views/user/getpwd.vue')
    },


]

const router = new VueRouter({
    routes
})

router.beforeEach((to, from, next) => {
    //localStorage.clear();
    //to到哪儿  from从哪儿离开  next跳转 为空就是放行  
    if (to.path === '/login' || to.path === '/getpwd') {
        //如果跳转为登录或找回密码，就放行 
        next();
    } else {
        //取出localStorage判断
        let token = localStorage.getItem('token');
        if (token == null || token === '') {
            console.log('请先登录')
            next({ path: '/login' });
        } else {
            next();
        }
    }
});

router.afterEach((to, from, next) => {
    window.scrollTo(0, 0);

});

export default router